import React, { forwardRef, useImperativeHandle, useState } from 'react';
import BootstrapTable from "react-bootstrap-table-next";
import { Card, CardBody, CardTitle } from 'reactstrap';

import { ActiveFormatter } from "../../../components/tables/activeFormater";
import { confirmAlert } from "react-confirm-alert";
import { ButtonTableDelete, ButtonTableEdit } from "../../../components/buttons/buttonsActions";
import { showLoader } from "../../../components/loader/loader";
import { routScheduleService } from "../../../jwt/_services/xailing/routScheduleService";
import {
	ARE_YOU_SHURE_MSG, ARE_YOU_SHURE_TITLE, error, LIST,
	NO, NO_DATA_FOUND, YES,
} from "../../../components/i18n/i18n";

export const RoutScheduleList = forwardRef((props, ref) => {
	const [fbDataBaseId] = useState(props?.app?.fbDataBase?.id);
	const [xailingRout] = useState(props.xailingRout);
	const [listItems, setListItems] = useState(props.xailingRout?.schedules || []);
	const [loading, setLoading] = useState(false);

	const handleTableChange = () => refreshDataList();

	const refreshDataList = () => {
		setLoading(true);
		setListItems([]);
		routScheduleService.search({ id : xailingRout?.id } )
			.then(result => {
				if (result)
					setListItems(result);
			 	else
					setListItems([]);
			})
			.finally(()=>setLoading(false))
	}

	useImperativeHandle(ref, () => ({
		refreshList() {
			refreshDataList();
		}
	}));

	// ----------------------------------------------
	//            TABLE BUTTONS
	// ----------------------------------------------
	const editItem = (data) => {
		const itemToEdit = listItems.find(n => n.id === data.id);
		props.setForm(true, itemToEdit);
	}

	const confirmDelete = (data) => {
		return confirmAlert({
			closeOnEscape: true,
			closeOnClickOutside: true,
			customUI: ({onClose}) => {
				return (
					<div className='custom-ui'>
						<h1>{ARE_YOU_SHURE_TITLE}</h1>
						<p>{ARE_YOU_SHURE_MSG}</p>
						<button onClick={onClose}>{NO}</button>
						<button className={"btn-alert-delete"} onClick={() => {
							deleteItem(data)
							onClose();
						}}>
							{YES}
						</button>
					</div>
				);
			}
		});
	};

	const deleteItem = (data) => {
		setLoading(true);

		routScheduleService.deleteItem(data.id, fbDataBaseId)
			.then(_ => refreshDataList())
			.finally(() => setLoading(false));
	}

	// ----------------------------------------------
	//            ROW FORMATTERS
	// ----------------------------------------------
	const activeFormatter = (cell) => <ActiveFormatter active={cell}/>

	const actionsFormatter = (cell, row) =>  <>
		<ButtonTableEdit onClick={() => editItem(row)}/>
		<ButtonTableDelete onClick={() => confirmDelete(row)}/>
	</>

	const columns = [
		{
			dataField: 'id',
			headerStyle: {width: '0px'},
			text: 'ID',
			hidden: true
		}, {
			dataField: 'time12',
			text: 'Hora (12 hrs)'
		}, {
			dataField: 'time24',
			text: 'Hora (24 hrs)'
		}, {
			dataField: 'status',
			text: "Activo",
			headerStyle: {width: '80px'},
			formatter: activeFormatter
		}, {
			dataField: 'actions',
			isDummyField: true,
			text: 'Acción',
			headerAlign: 'center',
			align: 'center',
			headerStyle: {width: '180px'},
			formatter: actionsFormatter
		}
	];

	return (
		<div>
			{loading && showLoader()}
			<Card>
				<CardTitle className="bg-light border-bottom p-3 mb-0">
					<i className="far fa-list-alt mr-2"> </i>{LIST}
				</CardTitle>

				<CardBody className="">
					<BootstrapTable
						striped hover
						tableHeaderClass='mb-0'
						remote
						keyField="id"
						data={listItems}
						columns={columns}
						noDataIndication={NO_DATA_FOUND}
						onTableChange={handleTableChange}
					/>
				</CardBody>
			</Card>
		</div>
	)
});
